const comments = [
  {
    avatar: 'https://readdy.ai/api/search-image?query=Cute%20anime%20style%20avatar%20portrait%20of%20a%20young%20person%20with%20warm%20smile%2C%20simple%20flat%20illustration%2C%20soft%20pastel%20colors%2C%20circle%20frame%2C%20minimalist%20design&width=120&height=120&seq=avatar-cmt-01&orientation=squarish',
    name: '星辰漫迷',
    time: '2小时前',
    content: '香蕉动漫真的太良心了！追了三个月的《修仙狂徒》一直免费看，画质清晰，加载速度也快，已经推荐给身边所有朋友了！',
    likes: 128,
    comic: '修仙狂徒',
  },
  {
    avatar: 'https://readdy.ai/api/search-image?query=Cute%20anime%20style%20avatar%20portrait%20of%20a%20girl%20with%20pink%20hair%2C%20simple%20flat%20illustration%2C%20soft%20pastel%20colors%2C%20circle%20frame%2C%20minimalist%20design&width=120&height=120&seq=avatar-cmt-02&orientation=squarish',
    name: '甜心教主',
    time: '5小时前',
    content: '终于找到可以免费看韩漫的地方了！《暗夜猎手》的画风绝了，而且不用翻墙不用付费，真的是宝藏平台。',
    likes: 96,
    comic: '暗夜猎手',
  },
  {
    avatar: 'https://readdy.ai/api/search-image?query=Cute%20anime%20style%20avatar%20portrait%20of%20a%20boy%20with%20glasses%2C%20simple%20flat%20illustration%2C%20soft%20pastel%20colors%2C%20circle%20frame%2C%20minimalist%20design&width=120&height=120&seq=avatar-cmt-03&orientation=squarish',
    name: '推理狂魔',
    time: '1天前',
    content: '最近迷上了悬疑推理类漫画，香蕉动漫收录了好多优质的完结推理作品，一口气看完太过瘾了，强烈安利！',
    likes: 75,
    comic: '密室逃脱',
  },
  {
    avatar: 'https://readdy.ai/api/search-image?query=Cute%20anime%20style%20avatar%20portrait%20of%20a%20young%20woman%20with%20long%20hair%2C%20simple%20flat%20illustration%2C%20soft%20pastel%20colors%2C%20circle%20frame%2C%20minimalist%20design&width=120&height=120&seq=avatar-cmt-04&orientation=squarish',
    name: '条漫少女',
    time: '2天前',
    content: '作为一个条漫重度爱好者，香蕉动漫的条漫专区简直是我的快乐源泉！《甜蜜陷阱》每天蹲更新，作者大大冲鸭！',
    likes: 203,
    comic: '甜蜜陷阱',
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-accent-100/70 text-accent-700 text-xs font-medium mb-4">
            <i className="ri-chat-1-line"></i>
            评论
          </div>
          <h2 className="font-heading text-2xl md:text-4xl text-foreground-950 mb-3">读者热评</h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-xl mx-auto">
            听听读者们怎么说，加入百万漫迷的讨论社区
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {comments.map((cmt, i) => (
            <div key={i} className="bg-background-50 rounded-xl p-5 md:p-6 flex flex-col">
              <div className="flex items-center gap-3 mb-4">
                <img
                  src={cmt.avatar}
                  alt={cmt.name}
                  className="w-10 h-10 rounded-full object-cover shrink-0"
                  onError={(e) => { (e.target as HTMLImageElement).style.display = 'none'; }}
                />
                <div className="min-w-0">
                  <div className="text-sm font-medium text-foreground-800 truncate">{cmt.name}</div>
                  <div className="text-xs text-foreground-400">{cmt.time}</div>
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed flex-1 mb-4">&ldquo;{cmt.content}&rdquo;</p>
              <div className="flex items-center justify-between pt-3 border-t border-background-200/70">
                <span className="text-xs text-foreground-400">正在阅读 <strong className="text-primary-500 font-medium">{cmt.comic}</strong></span>
                <span className="inline-flex items-center gap-1 text-xs text-foreground-400">
                  <i className="ri-heart-line text-accent-500 text-xs"></i>
                  {cmt.likes}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}